import { RouterItem } from "../interfaces/router-item.interface";

export const routerSidebarItems: RouterItem[] = [
  {
    title: 'SIDEBAR.CUSTOMERS',
    path: '/customers',
    icon: 'fa-users',
  },
  {
    title: 'SIDEBAR.DEACTIVATED_CUSTOMERS',
    path: '/deactivated-customers',
    icon: 'fa-users-slash',
  },
  {
    title: 'SIDEBAR.APPLICANTS',
    path: '/applicants',
    icon: 'fa-inbox',
  },
  {
    title: 'SIDEBAR.RULES',
    path: '/rules',
    icon: 'fa-screwdriver-wrench',
    groupToAccess: 'page_rules'
  },
  {
    title: 'SIDEBAR.SRDISCUSSION',
    path: '/srdiscussion',
    icon: 'fa-comment',
    groupToAccess: 'page_sritems'
  },
  {
    title: 'SIDEBAR.FEATURES',
    path: '/featurecomparison',
    icon: 'fa-scale-balanced',
    groupToAccess: 'page_features'
  },
  {
    title: 'SIDEBAR.QUESTIONNAIRE_EDITOR',
    path: '/questionnaire-editor',
    icon: 'fa-clipboard-list',
    groupToAccess: 'page_questions'
  }
];
